import { create } from 'zustand'

/**
 * Chrome state for the Centro de novedades, shared between
 * `NotificationCenter` (owns the panel + computes the pending count) and
 * the composition root (app-shell), which injects `pending` + an opener
 * into the bottom `ActionDock` (spec/clubmanager/15 BR-17 — the FAB was folded into
 * the dock). Kept in `shared/` so both the `shell` NotificationCenter
 * and the app-shell can use it without a feature-boundary hop, and the
 * `shared` ActionDock never needs to import it (it stays prop-driven —
 * same dependency-inversion as the Venta/Reserva triggers).
 */
interface NotificationCenterState {
  open: boolean
  /** Number of actionable items (setup-tutorial steps pending). Written
   *  by NotificationCenter; read by app-shell for the dock badge/dot. */
  pending: number
  openCenter: () => void
  closeCenter: () => void
  setPending: (n: number) => void
}

export const useNotificationCenterStore = create<NotificationCenterState>(
  (set) => ({
    open: false,
    pending: 0,
    openCenter: () => set({ open: true }),
    closeCenter: () => set({ open: false }),
    setPending: (n) => set({ pending: n }),
  }),
)
